<!-- eslint-disable -->
<template lang="pug">
  div.auth-footer
    a.auth-footer__link(href="http://cleverstart.ru/") &copy {{ currentYear }} CleverStart
</template>

<script>
    /*eslint-disable*/
  export default {
    computed: {
      currentYear () {
        return new Date().getFullYear();
      }
    }
  }
</script>

<style lang="scss" scoped>
  .auth-footer {
    text-align: center;
    margin-top: $space-large;
    margin-bottom: $space-large;
    &__link {
      @include text($font-size-14);
      color: $color-green-600;
    }
  }
</style>
